import { computeItemLayout } from '../../../core/geometry';
import type { ItemTransform, Vec2 } from '../../../core/model';

/** On-screen size of the item box (always positive), as shown in the Size fields. */
export function displayedSize(transform: ItemTransform, contentSize: Vec2): Vec2 {
  const { boxSize } = computeItemLayout(transform, contentSize);
  return { x: Math.abs(boxSize.x), y: Math.abs(boxSize.y) };
}

/**
 * Scale that gives the item the requested width or height while keeping the
 * current flip direction. Null when the content has no size on that axis yet.
 */
export function scaleForSize(transform: ItemTransform, contentSize: Vec2, axis: 'x' | 'y', size: number): number | null {
  const { crop } = transform;
  const content = axis === 'x' ? contentSize.x - crop.left - crop.right : contentSize.y - crop.top - crop.bottom;
  if (!(content > 0)) return null;
  const sign = transform.scale[axis] < 0 ? -1 : 1;
  return (sign * Math.max(0, size)) / content;
}
